import { Select } from '@consta/uikit/Select'
import { Text } from '@consta/uikit/Text'
import type { ActiveEntity, BaseEntity } from '@core/core/types'
import type { Nullable } from 'common/types'
import type { FC } from 'react'
import { useState } from 'react'

import css from './MapFetching.css'
import { TreeInputWithText } from './TreeInputWithText'

type AlgorithmItem = { label: string; id: number }

const algorithmItems: AlgorithmItem[] = [{ label: 'РБФ с линейным интерполятором', id: 0 }]

type LeftMenuProps = {
  chosenMap: Nullable<ActiveEntity<'map'>>
  chosenMarker: Nullable<ActiveEntity<'marker'>>
  onMapChange: (value: Nullable<ActiveEntity<'map'>>) => void
  onMarkerChange: (value: Nullable<ActiveEntity<'marker'>>) => void
}

export const LeftMenu: FC<LeftMenuProps> = ({
  chosenMap,
  chosenMarker,
  onMapChange,
  onMarkerChange,
}) => {
  const [algorithmItem, setCurrentAlgorithm] = useState<Nullable<AlgorithmItem>>(algorithmItems[0])

  return (
    <div className={`${css.menu} ${css.leftMenu}`}>
      <Text weight="semibold" size="s" className={css.headerDescription} view="primary">
        Входные данные
      </Text>
      <Text size="xs" view="secondary" className={css.borderBottom}>
        Объекты
      </Text>
      <div className={css.objectMenu}>
        <TreeInputWithText
          text="Карта"
          value={chosenMap}
          allowedTypes={['map']}
          color={chosenMap?.customProperties?.fillColor}
          treeInputProps={{
            placeholder: 'Выбрать карту',
            className: css.treeWidth,
          }}
          onChange={onMapChange as (value: Nullable<BaseEntity>) => void}
        />
        <TreeInputWithText
          text="Маркер"
          value={chosenMarker}
          allowedTypes={['marker']}
          color={chosenMarker?.customProperties?.fillColor}
          chooseEntityNameInsteadOfId={true}
          treeInputProps={{
            placeholder: 'Выбрать маркер',
            className: css.treeWidth,
          }}
          onChange={onMarkerChange as (value: Nullable<BaseEntity>) => void}
        />
      </div>
      <Text view="ghost" size="xs" className={css.textMargin}>
        После расчета карта невязок сохраняется в атрибуты выбранной карты
      </Text>
      <Text view="secondary" size="xs" className={css.borderBottom}>
        Алгоритм
      </Text>
      <div className={css.algorithmMenu}>
        <Select
          size="xs"
          label="Метод"
          disabled={true}
          items={algorithmItems}
          getItemKey={item => item.id}
          getItemLabel={item => item.label}
          value={algorithmItem}
          onChange={setCurrentAlgorithm}
        />
      </div>
    </div>
  )
}
